/**
 * ProductServiceFilter Component
 *
 * Multi-select filter for product/service categories.
 * Values are client-configured and loaded from the API.
 * Uses OR logic only - records matching ANY selected product are included.
 * (AND logic not supported as records have single product values)
 */

import { Package } from 'lucide-react';
import { FilterDropdown } from './FilterDropdown';
import type { BusinessContextFilterProps } from '../types/filter.types';

export function ProductServiceFilter({
  value,
  onChange,
  options,
  disabled = false,
  className,
}: BusinessContextFilterProps) {
  // Handle values change - always use OR logic for single-value fields
  const handleValuesChange = (values: string[] | undefined) => {
    if (!values || values.length === 0) {
      onChange(undefined);
    } else {
      onChange({
        values,
        logic: 'or',
      });
    }
  };

  return (
    <FilterDropdown
      value={value?.values}
      onChange={handleValuesChange}
      options={options}
      icon={<Package className="h-4 w-4" />}
      emptyLabel="All Products"
      pluralNoun="products"
      helperText="Select products (matches any)"
      disabled={disabled}
      className={className}
    />
  );
}
